import {
  UPDATE_BANKNOTIFICATION
} from './types';

/**
 *
 * @return {Function}
 */
const updateBankNotifications = state => (dispatch, getState) => {
  const { bankNotificationState } = getState();
  if (bankNotificationState && bankNotificationState.preventInputChanges) return;
  dispatch({ type: UPDATE_BANKNOTIFICATION, payload: state });
};

export default {
  updateBankNotifications,
};



// WEBPACK FOOTER //
// ./src/actions/bankNotification.js